'use client';

import React from 'react';

import {cn} from '@/lib/utils';

interface DividerProps {
    className?: string; // Optional prop for custom Tailwind classes
    bgClassName?: string; // Optional prop for custom Tailwind classes
}

export default function Divider({className, bgClassName = 'bg-primary'}: DividerProps) {
    return (
        <div className={cn("h-1 bg-muted rounded overflow-hidden", className)}>
            <div className={`w-full h-full ${bgClassName}`}/>
        </div>
    );
}
